// extracted by mini-css-extract-plugin
export default {"truncateBranch":"PullRequestBranchName-module__truncateBranch__lWQmdRY"};